import { call, put, select } from 'redux-saga/effects';
import { urls } from '../../../common/urls';
import { getHttp, getHttpwithtoken, postHttpwithtoken } from '../../../common/ApiCall';
import {
  tripUpComingFailure,
  tripUpComingLoading,
  tripUpComingSuccess,
  completedTripsFailure,
  completedTripsLoading,
  completedTripsSuccess,
} from '../../ducks/TripSlice';

// Trip Upcoming Handler
export function* handlerTripUpcoming(action: any): Generator<any, void, any> {
  try {
    yield put(tripUpComingLoading());
    const response: any = yield call(getHttpwithtoken, `${urls.baseURL}${urls.getupcomingTripCustomerorDriver}`);
    
    if (response.success) {
      yield put(tripUpComingSuccess(response.data));
    } else {
      yield put(tripUpComingFailure(response.message || 'Failed to get upcoming trips'));
    }
  } catch (error: any) {
    yield put(tripUpComingFailure(error.message || 'Failed to get upcoming trips'));
  }
}

// Completed Trips Handler
export function* handlerCompletedTrips(action: any): Generator<any, void, any> {
  try {
    yield put(completedTripsLoading());
    const response: any = yield call(getHttpwithtoken, `${urls.baseURL}${urls.getcompletedTripCustomerorDriver}`);
    
    if (response.success) {
      yield put(completedTripsSuccess(response.data));
    } else {
      yield put(completedTripsFailure(response.message || 'Failed to get completed trips'));
    }
  } catch (error: any) {
    yield put(completedTripsFailure(error.message || 'Failed to get completed trips'));
  }
}
